import React, { useEffect, useState } from 'react';
import { teamService, settingsService } from '../services/api';
import { isValidEmail } from '../utils/masks';
import { useAuth } from '../context/AuthContext';
import ImageUpload from '../components/ImageUpload';
import { applyAccent, DEFAULT_ACCENT } from '../utils/theme';

const TABS = [
  { key: 'company', label: 'Perfil da empresa', icon: '🏢' },
  { key: 'install', label: 'Instalar nos PCs', icon: '🖥️' },
  { key: 'users', label: 'Usuários', icon: '👥' },
  { key: 'portal', label: 'Portal do jogador', icon: '🌐' },
  { key: 'theme', label: 'Temas', icon: '🎨' },
  { key: 'apis', label: 'APIs', icon: '🔌' },
  { key: 'plan', label: 'Plano', icon: '💳' },
];

const WEEK_DAYS = [
  ['1','Segunda'],['2','Terça'],['3','Quarta'],['4','Quinta'],['5','Sexta'],['6','Sábado'],['0','Domingo'],
];
const DEFAULT_HOURS = {
  0:{open:true,start:'14:00',end:'22:00'},1:{open:false,start:'17:00',end:'22:00'},
  2:{open:true,start:'17:00',end:'22:00'},3:{open:true,start:'17:00',end:'22:00'},
  4:{open:true,start:'17:00',end:'22:00'},5:{open:true,start:'17:00',end:'22:00'},
  6:{open:true,start:'14:00',end:'22:00'},
};

function scheduleValue(value){
  let parsed=value;
  if(typeof value==='string'){try{parsed=JSON.parse(value);}catch(_){parsed={};}}
  return {days:{...DEFAULT_HOURS,...(parsed?.days||{})},interval_minutes:[30,60].includes(Number(parsed?.interval_minutes))?Number(parsed.interval_minutes):60,special_hours:Array.isArray(parsed?.special_hours)?parsed.special_hours:[]};
}

export default function Settings() {
  const [tab, setTab] = useState('install');
  return (
    <div>
      <div style={styles.header}>
        <h1 style={styles.title}>Configurações</h1>
      </div>
      <div style={styles.tabs}>
        {TABS.map(t => (
          <button key={t.key} onClick={() => setTab(t.key)}
            style={{ ...styles.tab, ...(tab === t.key ? styles.tabActive : {}) }}>
            <span>{t.icon}</span> {t.label}
          </button>
        ))}
      </div>
      {tab === 'install' && <InstallSection />}
      {tab === 'company' && <CompanySection />}
      {tab === 'users' && <UsersSection />}
      {tab === 'portal' && <PortalFeaturesSection />}
      {tab === 'theme' && <ThemeSection />}
      {tab === 'apis' && <ApisSection />}
      {tab === 'plan' && <PlanSection />}
    </div>
  );
}

const PORTAL_FEATURES = [
  ['portal_memberships_enabled', 'Assinaturas', 'Exibe os planos recorrentes e permite que jogadores assinem pelo portal.'],
  ['portal_booking_enabled', 'Agendamento / Booking', 'Permite que jogadores reservem equipamentos e horários.'],
  ['portal_promotions_enabled', 'Promoções', 'Exibe promoções e campanhas públicas no portal.'],
  ['portal_mix_enabled', 'MIX', 'Permite que jogadores organizem grupos MIX.'],
  ['portal_overnight_enabled', 'Corujão', 'Permite que jogadores organizem eventos durante a madrugada.'],
  ['portal_birthday_enabled', 'Aniversários', 'Disponibiliza pacotes de aniversário para jogadores.'],
  ['portal_championship_enabled', 'Campeonatos', 'Disponibiliza campeonatos e eventos competitivos.'],
];

function PortalFeaturesSection(){
  const [values,setValues]=useState({});const [saved,setSaved]=useState('');
  useEffect(()=>{settingsService.get().then(r=>{const s=r.data.settings||{},next={};PORTAL_FEATURES.forEach(([key])=>{next[key]=s[key]===undefined?true:s[key]==='1';});setValues(next);});},[]);
  const toggle=async key=>{const value=!values[key];setValues(v=>({...v,[key]:value}));setSaved('');try{await settingsService.update({[key]:value?'1':'0'});setSaved(key);setTimeout(()=>setSaved(''),1400);}catch(err){setValues(v=>({...v,[key]:!value}));alert('Erro: '+(err.response?.data?.error||err.message));}};
  return <div><div style={styles.sectionHead}><div><div style={styles.sectionTitle}>Recursos públicos do portal</div><div style={styles.sectionDesc}>Escolha o que seus jogadores podem acessar. Desativar não apaga reservas, pacotes ou eventos existentes.</div></div></div><div style={styles.panel}>{PORTAL_FEATURES.map(([key,title,desc])=><label key={key} style={{...styles.lockOpt,...(values[key]?styles.lockOptOn:{})}} onClick={()=>toggle(key)}><div style={{...styles.radio,...(values[key]?styles.radioOn:{})}}>{values[key]?'●':''}</div><div><div style={styles.lockLabel}>{title} {saved===key&&<span style={{color:'#22c55e',fontSize:11}}>✓ salvo</span>}</div><div style={styles.lockDesc}>{desc}</div></div></label>)}</div></div>;
}

function CompanySection(){
  const [f,setF]=useState({});const [saved,setSaved]=useState(false);
  useEffect(()=>{settingsService.getCompanyProfile().then(r=>setF({...r.data,opening_hours:scheduleValue(r.data.opening_hours)}));settingsService.get().then(r=>setF(x=>({...x,logo_url:r.data.settings?.logo_url||''})));},[]);
  const set=(k,v)=>{setSaved(false);setF({...f,[k]:v});};
  const setDay=(day,key,value)=>set('opening_hours',{...scheduleValue(f.opening_hours),days:{...scheduleValue(f.opening_hours).days,[day]:{...scheduleValue(f.opening_hours).days[day],[key]:value}}});
  const addSpecial=()=>set('opening_hours',{...scheduleValue(f.opening_hours),special_hours:[...scheduleValue(f.opening_hours).special_hours,{title:'Colônia de Férias',start_date:'',end_date:'',open:true,start:'13:00',end:'18:00'}]});
  const setSpecial=(index,key,value)=>{const special_hours=scheduleValue(f.opening_hours).special_hours.map((item,i)=>i===index?{...item,[key]:value}:item);set('opening_hours',{...scheduleValue(f.opening_hours),special_hours});};
  const removeSpecial=index=>set('opening_hours',{...scheduleValue(f.opening_hours),special_hours:scheduleValue(f.opening_hours).special_hours.filter((_,i)=>i!==index)});
  const save=async()=>{await settingsService.updateCompanyProfile(f);setSaved(true);};
  return <div><div style={styles.sectionHead}><div><div style={styles.sectionTitle}>Perfil completo da empresa</div><div style={styles.sectionDesc}>Informações exibidas no portal público dos jogadores.</div></div><button style={styles.btnPrimary} onClick={save}>{saved?'✓ Salvo':'Salvar perfil'}</button></div>
    <div style={styles.panel}><ImageUpload label="Logo da empresa" value={f.logo_url||''} onChange={v=>set('logo_url',v)}/>
      <Field label="Nome da empresa"><input style={styles.input} value={f.name||''} onChange={e=>set('name',e.target.value)}/></Field>
      <Field label="Razão social"><input style={styles.input} value={f.legal_name||''} onChange={e=>set('legal_name',e.target.value)}/></Field>
      <Field label="Descrição pública"><textarea style={{...styles.input,minHeight:90}} value={f.public_description||''} onChange={e=>set('public_description',e.target.value)}/></Field>
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(190px,1fr))',gap:12}}>{[['document','CPF/CNPJ'],['phone','Telefone'],['whatsapp','WhatsApp'],['postal_code','CEP'],['address_line','Endereço'],['address_number','Número'],['address_extra','Complemento'],['district','Bairro'],['city','Cidade'],['state','UF'],['website','Site'],['instagram','Instagram'],['facebook','Facebook']].map(([k,l])=><Field key={k} label={l}><input style={styles.input} value={f[k]||''} onChange={e=>set(k,e.target.value)}/></Field>)}</div>
      <div style={{...styles.panelTitle,marginTop:24}}>🕒 Horário de funcionamento e reservas</div>
      <div style={styles.sectionDesc}>Define os horários oferecidos no portal do jogador. Feriados e eventos específicos podem ser bloqueados na Agenda.</div>
      <div style={{marginTop:14}}>{WEEK_DAYS.map(([day,label])=>{const h=scheduleValue(f.opening_hours).days[day];return <div key={day} style={{display:'grid',gridTemplateColumns:'130px 90px 1fr 20px 1fr',gap:10,alignItems:'center',padding:'9px 0',borderBottom:'1px solid #292939'}}><strong style={{color:'#fff',fontSize:13}}>{label}</strong><label style={{color:h.open?'#a3e635':'#71717a',fontSize:12}}><input type="checkbox" checked={!!h.open} onChange={e=>setDay(day,'open',e.target.checked)}/> {h.open?'Aberto':'Fechado'}</label><input type="time" style={styles.input} disabled={!h.open} value={h.start} onChange={e=>setDay(day,'start',e.target.value)}/><span style={{color:'#71717a'}}>às</span><input type="time" style={styles.input} disabled={!h.open} value={h.end} onChange={e=>setDay(day,'end',e.target.value)}/></div>})}</div>
      <Field label="Intervalo mínimo das reservas"><select style={styles.input} value={scheduleValue(f.opening_hours).interval_minutes} onChange={e=>set('opening_hours',{...scheduleValue(f.opening_hours),interval_minutes:Number(e.target.value)})}><option value={60}>De 1 em 1 hora</option><option value={30}>De 30 em 30 minutos</option></select></Field>
      <div style={{...styles.sectionHead,marginTop:26,marginBottom:12}}><div><div style={styles.panelTitle}>⭐ Horários especiais</div><div style={styles.sectionDesc}>Substituem o horário semanal durante o período informado, sem alterar o padrão.</div></div><button type="button" style={styles.btnPrimary} onClick={addSpecial}>+ Horário especial</button></div>
      {scheduleValue(f.opening_hours).special_hours.map((item,index)=><div key={index} style={{padding:14,marginBottom:10,border:'1px solid #3f3f50',borderRadius:10,background:'#1c1c29'}}><div style={{display:'grid',gridTemplateColumns:'minmax(170px,2fr) minmax(140px,1fr) minmax(140px,1fr)',gap:10}}><Field label="Nome"><input style={styles.input} value={item.title||''} placeholder="Ex.: Colônia de Férias" onChange={e=>setSpecial(index,'title',e.target.value)}/></Field><Field label="Data inicial"><input type="date" style={styles.input} value={item.start_date||''} onChange={e=>setSpecial(index,'start_date',e.target.value)}/></Field><Field label="Data final"><input type="date" style={styles.input} value={item.end_date||''} onChange={e=>setSpecial(index,'end_date',e.target.value)}/></Field></div><div style={{display:'grid',gridTemplateColumns:'110px minmax(120px,1fr) 20px minmax(120px,1fr) auto',gap:10,alignItems:'end'}}><label style={{color:item.open!==false?'#a3e635':'#f87171',fontSize:12,paddingBottom:12}}><input type="checkbox" checked={item.open!==false} onChange={e=>setSpecial(index,'open',e.target.checked)}/> {item.open!==false?'Aberto':'Fechado'}</label><Field label="Abre às"><input type="time" style={styles.input} disabled={item.open===false} value={item.start||'13:00'} onChange={e=>setSpecial(index,'start',e.target.value)}/></Field><span style={{color:'#71717a',paddingBottom:12}}>às</span><Field label="Fecha às"><input type="time" style={styles.input} disabled={item.open===false} value={item.end||'18:00'} onChange={e=>setSpecial(index,'end',e.target.value)}/></Field><button type="button" style={{...styles.btnSecondary,color:'#f87171',marginBottom:2}} onClick={()=>removeSpecial(index)}>Excluir</button></div></div>)}
      {!scheduleValue(f.opening_hours).special_hours.length&&<div style={{...styles.sectionDesc,padding:'12px 0'}}>Nenhum horário especial cadastrado.</div>}
      <div style={styles.sectionDesc}>Portal público: /cliente/{f.slug||'empresa'}</div>
    </div></div>;
}

/* ------------------------------------------------- INSTALAR NOS PCs */
function InstallSection() {
  const [data, setData] = useState({ tenant: {}, download_url: '', client_version: '', client_notes: '' });
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(false);
  const [shutdownMinutes, setShutdownMinutes] = useState('10');
  const [cancelMinutes, setCancelMinutes] = useState('10');
  const [warningHours, setWarningHours] = useState('2');
  const [bookingSaved, setBookingSaved] = useState(false);
  const [shutdownSaved, setShutdownSaved] = useState(false);

  const load = async () => {
    const r = await settingsService.get();
    setData(r.data);
    setShutdownMinutes(r.data.settings?.pc_idle_shutdown_minutes ?? '10');
    setCancelMinutes(r.data.settings?.booking_cancel_minutes ?? '10');
    setWarningHours(r.data.settings?.booking_warning_hours ?? '2');
  };
  useEffect(() => { load(); }, []);

  const key = data.tenant?.pairing_key || '';
  // Nada de versão fixa no código: o botão mostra exatamente o que está
  // publicado no servidor. Um número chutado aqui levaria o técnico a baixar um
  // instalador que talvez nem exista mais — e o servidor responde a URL
  // inexistente com a própria página do painel, entregando um .exe inválido.
  const windows2Download = data.download_url || '';
  const displayVersion = data.client_version || '';
  const downloadReady = Boolean(windows2Download && displayVersion);

  // Versão em teste: aparece só quando o superadmin publica uma, e nunca é
  // distribuída sozinha — os PCs seguem na versão de produção acima.
  const testDownload = data.test_download_url || '';
  const testVersion = data.test_version || '';
  const testReady = Boolean(testDownload && testVersion && testVersion !== displayVersion);


  const copy = () => {
    navigator.clipboard?.writeText(key);
    setCopied(true); setTimeout(() => setCopied(false), 1500);
  };
  const regenerate = async () => {
    if (!window.confirm('Gerar uma nova chave? Os PCs já instalados continuam funcionando; só novas instalações precisam da nova chave.')) return;
    setLoading(true);
    try { await settingsService.regenerateKey(); load(); }
    catch (err) { alert('Erro: ' + (err.response?.data?.error || err.message)); }
    finally { setLoading(false); }
  };
  const saveShutdownTimer = async () => {
    const minutes = Math.max(0, Math.min(1440, Number.parseInt(shutdownMinutes, 10) || 0));
    setLoading(true);
    try {
      await settingsService.update({ pc_idle_shutdown_minutes: String(minutes) });
      setShutdownMinutes(String(minutes));
      setShutdownSaved(true);
      setTimeout(() => setShutdownSaved(false), 1800);
    } catch (err) {
      alert('Erro: ' + (err.response?.data?.error || err.message));
    } finally { setLoading(false); }
  };

  const saveBookingRules = async () => {
    const minutos = Math.max(0, Math.min(1440, Number.parseInt(cancelMinutes, 10) || 0));
    const horas = Math.max(0, Math.min(72, Number.parseInt(warningHours, 10) || 0));
    setLoading(true);
    try {
      await settingsService.update({
        booking_cancel_minutes: String(minutos),
        booking_warning_hours: String(horas),
      });
      setCancelMinutes(String(minutos));
      setWarningHours(String(horas));
      setBookingSaved(true);
      setTimeout(() => setBookingSaved(false), 1800);
    } catch (err) {
      alert('Erro: ' + (err.response?.data?.error || err.message));
    } finally { setLoading(false); }
  };

  const steps = [
    ['1', 'Baixe o instalador', 'Clique no botão abaixo e salve o ArenaClient no PC.'],
    ['2', 'Instale e abra', 'Rode o programa no computador que vai virar estação de jogo.'],
    ['3', 'Cole a chave', 'Na primeira vez, cole a chave de instalação abaixo.'],
    ['4', 'Pronto!', 'O PC aparece sozinho no seu Mapa da Arena, online (verde).'],
  ];

  return (
    <div>
      <div style={styles.sectionHead}>
        <div><div style={styles.sectionTitle}>Instalar o Arena nos PCs</div>
          <div style={styles.sectionDesc}>Baixe, instale e cole a chave. Cada PC aparece no mapa automaticamente.</div></div>
      </div>

      {/* Download */}
      <div style={styles.panel}>
        <div style={styles.panelTitle}>🖥️ Instalador Windows</div>
        <div style={{ color: '#fff', fontSize: 14, fontWeight: 800, margin: '12px 0 5px' }}>
          {downloadReady ? `ArenaCyberCafe Windows ${displayVersion}` : 'Consultando a versão publicada…'}
        </div>
        <div style={{ color: '#8b8b9e', fontSize: 12, marginBottom: 12 }}>
          {downloadReady
            ? (data.client_notes || 'Versão atual publicada para as estações.')
            : 'O botão libera assim que o servidor informar a versão.'}
        </div>
        {downloadReady ? (
          <a href={windows2Download} style={styles.downloadBtn} target="_blank" rel="noopener noreferrer">
            ⬇️ Baixar ArenaCyberCafe-Windows-{displayVersion}
          </a>
        ) : (
          <span style={{ ...styles.downloadBtn, opacity: 0.5, cursor: 'not-allowed' }}>
            ⏳ Carregando…
          </span>
        )}

        {testReady && (
          <div style={{ marginTop: 18, paddingTop: 16, borderTop: '1px solid #262636' }}>
            <div style={{ color: '#fbbf24', fontSize: 13, fontWeight: 800, marginBottom: 4 }}>
              🧪 Versão {testVersion} — em teste
            </div>
            <div style={{ color: '#8b8b9e', fontSize: 12, marginBottom: 12 }}>
              {data.test_notes || 'Disponível para instalação manual.'} Os PCs continuam
              atualizando para a {displayVersion} até esta ser aprovada.
            </div>
            <a
              href={testDownload}
              style={{ ...styles.downloadBtn, background: 'transparent', color: '#fbbf24', border: '1px solid #fbbf24' }}
              target="_blank"
              rel="noopener noreferrer"
            >
              ⬇️ Baixar ArenaCyberCafe-Windows-{testVersion} (teste)
            </a>
          </div>
        )}
      </div>

      {/* Chave */}
      <div style={styles.panel}>
        <div style={styles.panelTitle}>🔑 Chave de instalação</div>
        <div style={styles.sectionDesc}>Cole esta chave na primeira vez que abrir o Arena em cada PC.</div>
        <div style={styles.keyRow}>
          <code style={styles.keyBox}>{key || '—'}</code>
          <button style={styles.btnPrimary} onClick={copy}>{copied ? '✓ Copiado' : 'Copiar'}</button>
          <button style={styles.btnGhost} onClick={regenerate} disabled={loading}>Regenerar</button>
        </div>
      </div>

      {/* Economia de energia */}
      <div style={styles.panel}>
        <div style={styles.panelTitle}>⚡ Timer Shutdown</div>
        <div style={styles.sectionDesc}>Desliga automaticamente um PC online que permanecer sem usuário e sem sessão durante o período configurado. Qualquer login cancela o timer.</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 14, flexWrap: 'wrap' }}>
          <input
            type="number"
            min="0"
            max="1440"
            step="1"
            value={shutdownMinutes}
            onChange={e => setShutdownMinutes(e.target.value)}
            style={{ ...styles.input, width: 120 }}
            aria-label="Timer Shutdown em minutos"
          />
          <strong style={{ color: '#fff', fontSize: 13 }}>min</strong>
          <button type="button" style={styles.btnPrimary} onClick={saveShutdownTimer} disabled={loading}>
            {shutdownSaved ? '✓ Salvo' : 'Salvar'}
          </button>
        </div>
        <div style={{ ...styles.sectionDesc, marginTop: 8 }}>Padrão: 10 minutos. Digite 0 para desativar o desligamento automático.</div>
      </div>

      {/* Regras de agendamento */}
      <div style={styles.panel}>
        <div style={styles.panelTitle}>📅 Regras de agendamento</div>
        <div style={styles.sectionDesc}>
          A reserva é paga com o saldo do jogador. Estes prazos definem até quando ele pode
          desistir e com quanta antecedência quem está na máquina é avisado.
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 14, flexWrap: 'wrap' }}>
          <input type="number" min="0" max="1440" step="1" value={cancelMinutes}
            onChange={e => setCancelMinutes(e.target.value)}
            style={{ ...styles.input, width: 120 }}
            aria-label="Prazo de cancelamento em minutos" />
          <strong style={{ color: '#fff', fontSize: 13 }}>min antes — cancelamento com devolução</strong>
        </div>
        <div style={{ ...styles.sectionDesc, marginTop: 6 }}>
          Passado o prazo, a reserva é considerada confirmada e o valor não é devolvido —
          o jogador que estava na máquina já foi avisado de que seria interrompido.
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 16, flexWrap: 'wrap' }}>
          <input type="number" min="0" max="72" step="1" value={warningHours}
            onChange={e => setWarningHours(e.target.value)}
            style={{ ...styles.input, width: 120 }}
            aria-label="Antecedência do aviso em horas" />
          <strong style={{ color: '#fff', fontSize: 13 }}>h antes — aviso ao jogador na máquina</strong>
          <button type="button" style={styles.btnPrimary} onClick={saveBookingRules} disabled={loading}>
            {bookingSaved ? '✓ Salvo' : 'Salvar'}
          </button>
        </div>
        <div style={{ ...styles.sectionDesc, marginTop: 6 }}>
          Quem loga com a reserva ainda distante não é incomodado. Digite 0 para não avisar.
        </div>
      </div>

      {/* Passo a passo */}
      <div style={styles.panel}>
        <div style={styles.panelTitle}>Como instalar (4 passos)</div>
        {steps.map(([n, t, d]) => (
          <div key={n} style={styles.step}>
            <div style={styles.stepNum}>{n}</div>
            <div><div style={styles.stepTitle}>{t}</div><div style={styles.stepDesc}>{d}</div></div>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ------------------------------------------------- USUÁRIOS */
function UsersSection() {
  const { operator } = useAuth();
  const [team, setTeam] = useState([]);
  const [modal, setModal] = useState(null);   // {member?}
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);

  const load = async () => { const r = await teamService.getAll(); setTeam(r.data); };
  useEffect(() => { load(); }, []);

  const openNew = () => { setForm({ name: '', email: '', password: '', role: 'operator', is_active: true, avatar_url: '' }); setModal({}); };
  const openEdit = (m) => { setForm({ name: m.name, email: m.email, password: '', role: m.role, is_active: !!m.is_active, avatar_url: m.avatar_url || '' }); setModal({ member: m }); };

  const emailInvalid = !!form.email && !isValidEmail(form.email);

  const save = async () => {
    if (!form.name || (!modal.member && (!form.email || !form.password))) { alert('Preencha nome, e-mail e senha'); return; }
    if (emailInvalid) { alert('E-mail inválido'); return; }
    setLoading(true);
    try {
      if (modal.member) await teamService.update(modal.member.id, { name: form.name, role: form.role, is_active: form.is_active, password: form.password || undefined, avatar_url: form.avatar_url || '' });
      else await teamService.create({ name: form.name, email: form.email, password: form.password, role: form.role, avatar_url: form.avatar_url || '' });
      setModal(null); load();
    } catch (err) { alert('Erro: ' + (err.response?.data?.error || err.message)); }
    finally { setLoading(false); }
  };

  return (
    <div>
      <div style={styles.sectionHead}>
        <div><div style={styles.sectionTitle}>Equipe e privilégios</div>
          <div style={styles.sectionDesc}>Operadores desta lan house. Admin gerencia tudo; Operador opera o dia a dia.</div></div>
        <button style={styles.btnPrimary} onClick={openNew}>+ Usuário</button>
      </div>

      <div style={styles.panel}>
        {team.map(m => (
          <div key={m.id} style={styles.row}>
            {m.avatar_url
              ? <img src={m.avatar_url} alt={m.name} style={{ ...styles.avatar, objectFit: 'cover', padding: 0 }} />
              : <div style={styles.avatar}>{m.name.charAt(0).toUpperCase()}</div>}
            <div style={{ flex: 1 }}>
              <div style={styles.rowName}>{m.name} {m.id === operator?.id && <span style={styles.you}>você</span>}</div>
              <div style={styles.rowSub}>{m.email}</div>
            </div>
            <span style={{ ...styles.roleBadge, ...(m.role === 'admin' ? styles.roleAdmin : styles.roleOp) }}>
              {m.role === 'admin' ? 'Administrador' : 'Operador'}
            </span>
            {!m.is_active && <span style={styles.inactive}>inativo</span>}
            <button style={styles.btnGhost} onClick={() => openEdit(m)}>Editar</button>
          </div>
        ))}
      </div>

      {modal && (
        <Modal title={modal.member ? 'Editar usuário' : 'Novo usuário'}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 14 }}>
            {form.avatar_url
              ? <img src={form.avatar_url} alt="foto" style={{ width: 56, height: 56, borderRadius: '50%', objectFit: 'cover', border: '1px solid #34344e' }} />
              : <div style={{ ...styles.avatar, width: 56, height: 56, fontSize: 22 }}>{(form.name || '?').charAt(0).toUpperCase()}</div>}
            <div style={{ flex: 1 }}>
              <ImageUpload label="Foto do usuário" value={form.avatar_url}
                onChange={(u) => setForm({ ...form, avatar_url: u })} />
            </div>
          </div>
          <Field label="Nome *"><input style={styles.input} value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} /></Field>
          {!modal.member && (
            <Field label="E-mail (login) *"><input style={{ ...styles.input, ...(emailInvalid ? styles.inputErr : {}) }} value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} /></Field>
          )}
          <Field label={modal.member ? 'Nova senha (deixe vazio p/ manter)' : 'Senha *'}>
            <input type="password" style={styles.input} value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} />
          </Field>
          <Field label="Privilégio">
            <select style={styles.input} value={form.role} onChange={e => setForm({ ...form, role: e.target.value })}>
              <option value="operator">Operador</option>
              <option value="admin">Administrador</option>
            </select>
          </Field>
          {modal.member && (
            <label style={styles.check}><input type="checkbox" checked={!!form.is_active} onChange={e => setForm({ ...form, is_active: e.target.checked })} /> Ativo</label>
          )}
          <Actions onCancel={() => setModal(null)} onSave={save} loading={loading} />
        </Modal>
      )}
    </div>
  );
}

/* ------------------------------------------------- TEMAS */
const PRESETS = [
  { name: 'Verde limão', color: '#a3e635' },
  { name: 'Ciano', color: '#22d3ee' },
  { name: 'Azul', color: '#60a5fa' },
  { name: 'Magenta', color: '#e879f9' },
  { name: 'Roxo', color: '#a78bfa' },
  { name: 'Laranja', color: '#fb923c' },
  { name: 'Vermelho', color: '#f87171' },
  { name: 'Dourado', color: '#fbbf24' },
];

function ThemeSection() {
  const [url, setUrl] = useState('');
  const [logo, setLogo] = useState('');
  const [accent, setAccent] = useState(DEFAULT_ACCENT);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    settingsService.get().then(r => {
      setUrl(r.data.settings?.login_bg_url || '');
      setLogo(r.data.settings?.logo_url || '');
      setAccent(r.data.settings?.theme_accent || DEFAULT_ACCENT);
    });
  }, []);

  // prévia ao vivo: muda a cor do painel na hora
  const pickAccent = (c) => { setAccent(c); applyAccent(c); setSaved(false); };

  const save = async () => {
    setLoading(true);
    try { await settingsService.update({ login_bg_url: url, logo_url: logo, theme_accent: accent }); applyAccent(accent); setSaved(true); }
    catch (err) { alert('Erro: ' + (err.response?.data?.error || err.message)); }
    finally { setLoading(false); }
  };

  return (
    <div>
      <div style={styles.sectionHead}>
        <div><div style={styles.sectionTitle}>Tema</div>
          <div style={styles.sectionDesc}>Personalize a cor de destaque e o fundo do login da sua lan house.</div></div>
        <button style={styles.btnPrimary} onClick={save} disabled={loading}>{loading ? 'Salvando...' : saved ? '✓ Salvo' : 'Salvar'}</button>
      </div>

      {/* COR DE DESTAQUE */}
      <div style={styles.panel}>
        <div style={styles.panelTitle}>🎨 Cor de destaque</div>
        <div style={styles.sectionDesc}>Escolha um preset ou uma cor personalizada. A prévia é aplicada na hora.</div>
        <div style={styles.swatches}>
          {PRESETS.map(p => (
            <button key={p.color} title={p.name} onClick={() => pickAccent(p.color)}
              style={{ ...styles.swatch, background: p.color, outline: accent.toLowerCase() === p.color.toLowerCase() ? '3px solid #fff' : 'none' }} />
          ))}
        </div>
        <div style={styles.customRow}>
          <label style={styles.label}>Cor personalizada</label>
          <input type="color" value={accent} onChange={e => pickAccent(e.target.value)} style={styles.colorInput} />
          <input style={{ ...styles.input, maxWidth: 130 }} value={accent} onChange={e => pickAccent(e.target.value)} />
          <button style={styles.btnGhost} onClick={() => pickAccent(DEFAULT_ACCENT)}>Padrão</button>
        </div>
        <div style={styles.accentDemo}>
          <button style={{ ...styles.btnPrimary, background: accent, color: '#0a0a0f' }}>Botão de exemplo</button>
          <span style={{ color: accent, fontWeight: 700, marginLeft: 14 }}>Texto em destaque</span>
        </div>
      </div>

      {/* LOGO DO CYBER CAFÉ */}
      <div style={styles.panel}>
        <div style={styles.panelTitle}>🏷️ Logo do cyber café</div>
        <div style={styles.sectionDesc}>Sua marca aparece no painel e nas telas do PC do cliente (no lugar da logo Arena). Ideal: PNG com fundo transparente.</div>
        <ImageUpload label="Logo (envie um arquivo)" height={120}
          value={logo} onChange={(u) => { setLogo(u); setSaved(false); }} />
        {logo && (
          <div style={{ marginTop: 10, background: '#0a0a0f', border: '1px solid #262636', borderRadius: 10, padding: 16, display: 'inline-block' }}>
            <img src={logo} alt="logo" style={{ maxHeight: 46, maxWidth: 240 }} />
          </div>
        )}
      </div>

      {/* FUNDO DO LOGIN */}
      <div style={styles.panel}>
        <div style={styles.panelTitle}>🖼️ Fundo da tela de login</div>
        <ImageUpload label="Imagem de fundo (envie um arquivo)" height={160}
          value={url} onChange={(u) => { setUrl(u); setSaved(false); }} />
        <div style={styles.previewLabel}>Prévia</div>
        <div style={{ ...styles.preview, backgroundImage: url ? `url(${url})` : 'none' }}>
          {!url && <span style={styles.previewEmpty}>Sem imagem — fundo padrão</span>}
          <div style={styles.previewCard}>ARENA</div>
        </div>
      </div>
    </div>
  );
}

/* ------------------------------------------------- APIS */
function ApisSection() {
  const [data, setData] = useState({ settings: {}, tenant: {} });
  const [pay, setPay] = useState({ mp_access_token: '', asaas_api_key: '' });
  const [ai, setAi] = useState({ groq_api_key: '', openai_api_key: '' });
  const [msg, setMsg] = useState('');
  const [mpTest, setMpTest] = useState(null);
  const [testing, setTesting] = useState(false);
  const [asaasTest, setAsaasTest] = useState(null);
  const [testingAsaas, setTestingAsaas] = useState(false);

  const testMp = async () => {
    setTesting(true); setMpTest(null);
    try {
      if (pay.mp_access_token) {
        await settingsService.updatePayments({ mp_access_token: pay.mp_access_token });
        setPay(p => ({ ...p, mp_access_token: '' }));
        await load();
      }
      const r = await settingsService.testMp();
      setMpTest(r.data);
    } catch (err) {
      setMpTest({ connected: false, error: err.response?.data?.error || err.message });
    } finally { setTesting(false); }
  };

  const testAsaas = async () => {
    setTestingAsaas(true); setAsaasTest(null);
    try {
      if (pay.asaas_api_key) {
        await settingsService.updatePayments({ asaas_api_key: pay.asaas_api_key });
        setPay(p => ({ ...p, asaas_api_key: '' }));
        await load();
      }
      const r = await settingsService.testAsaas();
      setAsaasTest(r.data);
    } catch (err) {
      setAsaasTest({ connected: false, error: err.response?.data?.error || err.message });
    } finally { setTestingAsaas(false); }
  };

  const load = async () => {
    const r = await settingsService.get();
    setData(r.data);
    setAi({ groq_api_key: r.data.settings?.groq_api_key || '', openai_api_key: r.data.settings?.openai_api_key || '' });
  };
  useEffect(() => { load(); }, []);

  const savePay = async () => {
    const payload = {};
    if (pay.mp_access_token) payload.mp_access_token = pay.mp_access_token;
    if (pay.asaas_api_key) payload.asaas_api_key = pay.asaas_api_key;
    await settingsService.updatePayments(payload);
    setPay({ mp_access_token: '', asaas_api_key: '' }); setMsg('Chaves de pagamento salvas'); load();
  };
  const saveAi = async () => {
    await settingsService.update(ai); setMsg('Chaves de IA salvas'); load();
  };

  return (
    <div>
      {msg && <div style={styles.toast}>{msg}</div>}

      <div style={styles.panel}>
        <div style={styles.panelTitle}>💳 Pagamentos (recebe dos seus clientes)</div>
        <Field label={`Mercado Pago — Access Token ${data.tenant.has_mp ? '(configurado ✓)' : ''}`}>
          <input style={styles.input} type="password" placeholder={data.tenant.has_mp ? '•••• (deixe vazio p/ manter)' : 'cole o token'}
            value={pay.mp_access_token} onChange={e => setPay({ ...pay, mp_access_token: e.target.value })} />
        </Field>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, margin: '2px 0 4px' }}>
          <button style={{ padding: '8px 14px', background: 'transparent', color: '#cbd5e1', border: '1px solid #374151', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 600 }} onClick={testMp} disabled={testing}>
            {testing ? 'Testando…' : '🔌 Testar chave'}
          </button>
          {mpTest && mpTest.connected && (
            <span style={{ color: '#22c55e', fontWeight: 700, fontSize: 14 }}>
              ● Conectado{mpTest.account ? ` — ${mpTest.account}` : ''}{mpTest.test_mode ? ' (modo teste)' : ''}
            </span>
          )}
          {mpTest && !mpTest.connected && (
            <span style={{ color: '#ef4444', fontWeight: 700, fontSize: 14 }}>● Falhou — {mpTest.error}</span>
          )}
        </div>
        <Field label={`Asaas — API Key ${data.tenant.has_asaas ? '(configurado ✓)' : ''}`}>
          <input style={styles.input} type="password" placeholder={data.tenant.has_asaas ? '•••• (deixe vazio p/ manter)' : 'cole a chave'}
            value={pay.asaas_api_key} onChange={e => setPay({ ...pay, asaas_api_key: e.target.value })} />
        </Field>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, margin: '2px 0 4px' }}>
          <button style={{ padding: '8px 14px', background: 'transparent', color: '#cbd5e1', border: '1px solid #374151', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 600 }} onClick={testAsaas} disabled={testingAsaas}>
            {testingAsaas ? 'Testando…' : '🔌 Testar chave'}
          </button>
          {asaasTest && asaasTest.connected && (
            <span style={{ color: '#22c55e', fontWeight: 700, fontSize: 14 }}>
              ● Conectado{asaasTest.account ? ` — ${asaasTest.account}` : ''}{asaasTest.test_mode ? ' (sandbox)' : ''}
            </span>
          )}
          {asaasTest && !asaasTest.connected && (
            <span style={{ color: '#ef4444', fontWeight: 700, fontSize: 14 }}>● Falhou — {asaasTest.error}</span>
          )}
        </div>
        <div style={styles.rightBtn}><button style={styles.btnPrimary} onClick={savePay}>Salvar pagamentos</button></div>
      </div>

      <div style={styles.panel}>
        <div style={styles.panelTitle}>🤖 Inteligência Artificial</div>
        <Field label="Groq — API Key">
          <input style={styles.input} type="password" value={ai.groq_api_key} onChange={e => setAi({ ...ai, groq_api_key: e.target.value })} />
        </Field>
        <Field label="OpenAI (ChatGPT) — API Key">
          <input style={styles.input} type="password" value={ai.openai_api_key} onChange={e => setAi({ ...ai, openai_api_key: e.target.value })} />
        </Field>
        <div style={styles.rightBtn}><button style={styles.btnPrimary} onClick={saveAi}>Salvar IAs</button></div>
      </div>
    </div>
  );
}

/* ------------------------------------------------- PLANO */
function PlanSection() {
  const { operator } = useAuth();
  const [data, setData] = useState({ tenant: {}, plans: [] });
  const [loading, setLoading] = useState(false);

  const load = async () => { const r = await settingsService.get(); setData(r.data); };
  useEffect(() => { load(); }, []);

  const change = async (planId) => {
    if (operator?.role !== 'admin') { alert('Só o administrador pode mudar o plano'); return; }
    if (!window.confirm('Mudar para este plano?')) return;
    setLoading(true);
    try { await settingsService.updatePlan({ plan_id: planId }); load(); }
    catch (err) { alert('Erro: ' + (err.response?.data?.error || err.message)); }
    finally { setLoading(false); }
  };

  const feats = (f) => { try { return Array.isArray(f) ? f : (JSON.parse(f) || []); } catch { return []; } };
  const STATUS = { trial: 'Período de teste', active: 'Ativa', past_due: 'Pagamento atrasado', canceled: 'Cancelada' };

  return (
    <div>
      <div style={styles.currentPlan}>
        <div>
          <div style={styles.cpLabel}>SEU PLANO</div>
          <div style={styles.cpName}>{data.tenant.plan_name || 'Sem plano'}</div>
          <div style={styles.cpStatus}>{STATUS[data.tenant.subscription_status] || data.tenant.subscription_status}</div>
        </div>
        <div style={styles.cpPrice}>R$ {Number(data.tenant.price_monthly || 0).toFixed(2)}<span style={styles.cpPer}>/mês</span></div>
      </div>

      <div style={styles.sectionTitle}>Planos disponíveis</div>
      <div style={styles.plansGrid}>
        {data.plans.map(p => {
          const current = p.id === data.tenant.plan_id;
          return (
            <div key={p.id} style={{ ...styles.planCard, ...(current ? styles.planCurrent : {}) }}>
              <div style={styles.planName}>{p.name}</div>
              <div style={styles.planPrice}>R$ {Number(p.price_monthly).toFixed(2)}<span style={styles.cpPer}>/mês</span></div>
              <div style={styles.planMachines}>{p.max_machines > 0 ? `até ${p.max_machines} máquinas` : 'máquinas ilimitadas'}</div>
              <ul style={styles.feats}>{feats(p.features).map((f, i) => <li key={i} style={styles.feat}>✓ {f}</li>)}</ul>
              {current
                ? <div style={styles.currentTag}>Plano atual</div>
                : <button style={styles.btnPrimary} onClick={() => change(p.id)} disabled={loading}>Mudar para este</button>}
            </div>
          );
        })}
      </div>

      <div style={styles.paymentsBox}>
        <div style={styles.panelTitle}>Pagamentos da assinatura</div>
        <div style={styles.sectionDesc}>
          A cobrança automática da assinatura (via Asaas) é ativada na próxima etapa.
          Por enquanto a troca de plano é registrada e o financeiro é acertado com a Agência Interativa.
        </div>
      </div>
    </div>
  );
}

/* ------------------------------------------------- helpers */
function Modal({ title, children }) {
  return <div style={styles.overlay}><div style={styles.modal}><h2 style={styles.modalTitle}>{title}</h2>{children}</div></div>;
}
function Field({ label, children }) {
  return <div style={{ marginBottom: 14 }}><label style={styles.label}>{label}</label>{children}</div>;
}
function Actions({ onCancel, onSave, loading }) {
  return <div style={styles.modalActions}>
    <button style={styles.btnGhost} onClick={onCancel}>Cancelar</button>
    <button style={styles.btnPrimary} onClick={onSave} disabled={loading}>{loading ? '...' : 'Salvar'}</button>
  </div>;
}

const styles = {
  header: { marginBottom: 16 },
  title: { color: '#fff', fontSize: 24, fontWeight: 700, margin: 0 },
  tabs: { display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 24, borderBottom: '1px solid #262636', paddingBottom: 12 },
  tab: { display: 'flex', alignItems: 'center', gap: 6, padding: '8px 16px', background: 'transparent', border: '1px solid #262636', borderRadius: 8, color: '#9ca3af', cursor: 'pointer', fontSize: 14, fontWeight: 500 },
  tabActive: { background: '#1e3a5f', color: '#60a5fa', border: '1px solid #1e3a5f' },
  sectionHead: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12, marginBottom: 16 },
  sectionTitle: { color: '#fff', fontSize: 17, fontWeight: 700, marginBottom: 12 },
  sectionDesc: { color: '#6b7280', fontSize: 13, marginTop: 2, maxWidth: 620 },
  panel: { background: '#14141f', border: '1px solid #262636', borderRadius: 12, padding: 20, marginBottom: 18, maxWidth: 680 },
  panelTitle: { color: '#fff', fontSize: 15, fontWeight: 700, marginBottom: 14 },
  row: { display: 'flex', alignItems: 'center', gap: 12, padding: '10px 0', borderBottom: '1px solid #262636' },
  avatar: { width: 36, height: 36, borderRadius: '50%', background: '#1e3a5f', color: '#60a5fa', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700 },
  rowName: { color: '#fff', fontWeight: 600, fontSize: 14 },
  rowSub: { color: '#6b7280', fontSize: 12 },
  you: { fontSize: 10, background: '#1e3a5f', color: '#93c5fd', padding: '1px 6px', borderRadius: 10, marginLeft: 6 },
  roleBadge: { fontSize: 11, fontWeight: 600, padding: '3px 9px', borderRadius: 20 },
  roleAdmin: { background: '#1a2e05', color: 'var(--accent)' },
  roleOp: { background: '#262636', color: '#9ca3af' },
  inactive: { fontSize: 11, color: '#f87171' },
  btnPrimary: { padding: '9px 16px', background: 'var(--accent)', color: '#0a0a0f', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 600 },
  btnGhost: { padding: '7px 12px', background: 'transparent', border: '1px solid #374151', borderRadius: 8, color: '#9ca3af', cursor: 'pointer', fontSize: 13 },
  rightBtn: { display: 'flex', justifyContent: 'flex-end', marginTop: 4 },
  toast: { background: '#052e16', color: '#4ade80', border: '1px solid #14532d', borderRadius: 8, padding: '10px 14px', marginBottom: 16, fontSize: 14 },
  previewLabel: { color: '#6b7280', fontSize: 12, margin: '4px 0 8px' },
  preview: { height: 180, borderRadius: 10, backgroundSize: 'cover', backgroundPosition: 'center', background: '#0a0a0f', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', border: '1px solid #262636' },
  previewEmpty: { position: 'absolute', color: '#6b7280', fontSize: 13 },
  previewCard: { background: 'rgba(17,24,39,0.9)', color: 'var(--accent)', fontWeight: 800, letterSpacing: 3, padding: '16px 28px', borderRadius: 10, fontSize: 20 },
  currentPlan: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'linear-gradient(135deg, #14210a, #14141f)', border: '1px solid #3f6212', borderRadius: 14, padding: 22, marginBottom: 24 },
  cpLabel: { color: '#bef264', fontSize: 11, fontWeight: 700, letterSpacing: 2 },
  cpName: { color: '#fff', fontSize: 26, fontWeight: 800, margin: '4px 0' },
  cpStatus: { color: '#9ca3af', fontSize: 13 },
  cpPrice: { color: '#fff', fontSize: 28, fontWeight: 800 },
  cpPer: { color: '#6b7280', fontSize: 14, fontWeight: 500 },
  plansGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 16, marginBottom: 24 },
  planCard: { background: '#14141f', border: '1px solid #262636', borderRadius: 14, padding: 20, display: 'flex', flexDirection: 'column', gap: 6 },
  planCurrent: { border: '1px solid var(--accent)' },
  planName: { color: '#bef264', fontWeight: 700, fontSize: 17 },
  planPrice: { color: '#fff', fontSize: 24, fontWeight: 800 },
  planMachines: { color: '#9ca3af', fontSize: 13 },
  feats: { listStyle: 'none', margin: '8px 0', padding: 0, display: 'flex', flexDirection: 'column', gap: 5 },
  feat: { color: '#9ca3af', fontSize: 13 },
  currentTag: { textAlign: 'center', color: 'var(--accent)', fontSize: 13, fontWeight: 600, padding: '9px', border: '1px solid var(--accent)', borderRadius: 8, marginTop: 6 },
  paymentsBox: { background: '#14141f', border: '1px solid #262636', borderRadius: 12, padding: 20, maxWidth: 680 },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.65)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50, padding: 16 },
  modal: { background: '#14141f', border: '1px solid #262636', borderRadius: 16, padding: 28, width: 420, maxWidth: '100%', maxHeight: '90vh', overflowY: 'auto' },
  modalTitle: { color: '#fff', fontSize: 20, fontWeight: 700, margin: '0 0 20px' },
  label: { display: 'block', color: '#9ca3af', fontSize: 13, fontWeight: 500, marginBottom: 6 },
  input: { width: '100%', padding: '10px 12px', background: '#262636', border: '1px solid #374151', borderRadius: 8, color: '#fff', fontSize: 14, boxSizing: 'border-box' },
  inputErr: { border: '1px solid #ef4444' },
  check: { display: 'flex', alignItems: 'center', gap: 8, color: '#e5e7eb', fontSize: 14, marginBottom: 8, cursor: 'pointer' },
  modalActions: { display: 'flex', gap: 12, justifyContent: 'flex-end', marginTop: 20 },
  downloadBtn: { display: 'inline-block', padding: '14px 24px', background: 'var(--accent)', color: '#0a0a0f', textDecoration: 'none', borderRadius: 10, fontSize: 16, fontWeight: 700 },
  notReady: { color: '#f59e0b', fontSize: 14, background: '#1a1206', border: '1px solid #451a03', borderRadius: 8, padding: '12px 14px' },
  keyRow: { display: 'flex', gap: 10, alignItems: 'center', marginTop: 10, flexWrap: 'wrap' },
  keyBox: { flex: 1, minWidth: 220, background: '#0a0a0f', border: '1px solid #374151', borderRadius: 8, padding: '11px 14px', color: '#34d399', fontSize: 14, fontFamily: 'monospace', wordBreak: 'break-all' },
  step: { display: 'flex', gap: 14, alignItems: 'flex-start', padding: '10px 0', borderBottom: '1px solid #262636' },
  stepNum: { width: 28, height: 28, minWidth: 28, borderRadius: '50%', background: 'var(--accent)', color: '#0a0a0f', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 14 },
  stepTitle: { color: '#fff', fontSize: 14, fontWeight: 600 },
  stepDesc: { color: '#9ca3af', fontSize: 13, marginTop: 2 },
  swatches: { display: 'flex', gap: 12, flexWrap: 'wrap', margin: '12px 0' },
  swatch: { width: 40, height: 40, borderRadius: 10, border: '1px solid #262636', cursor: 'pointer', outlineOffset: 2 },
  customRow: { display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap', marginTop: 6 },
  colorInput: { width: 44, height: 40, border: 'none', background: 'transparent', cursor: 'pointer', padding: 0 },
  accentDemo: { display: 'flex', alignItems: 'center', marginTop: 18, paddingTop: 16, borderTop: '1px solid #262636' },
  lockOpt: { display: 'flex', gap: 12, alignItems: 'flex-start', padding: '12px 14px', border: '1px solid #262636', borderRadius: 10, marginBottom: 10, cursor: 'pointer' },
  lockOptOn: { border: '1px solid var(--accent)', background: '#12140c' },
  radio: { width: 20, height: 20, minWidth: 20, borderRadius: '50%', border: '2px solid #4b5563', color: 'var(--accent)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, marginTop: 1 },
  radioOn: { borderColor: 'var(--accent)' },
  lockLabel: { color: '#fff', fontSize: 14, fontWeight: 600 },
  lockDesc: { color: '#9ca3af', fontSize: 13, marginTop: 2 },
  lockNote: { color: '#93c5fd', fontSize: 13, background: '#0f172a', border: '1px solid #1e3a5f', borderRadius: 8, padding: '10px 12px', marginTop: 8 },
};
